const Section = ({ children }) => {
    return (
        <section className="py-5">{children}</section>
    );
}

export default Section;